import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M20.63 21.646c-5.584-4.062-.507-6.093 0-4.062.296 1.182-2.225 2.46-3.278 3.046-1.599.89-3.388 1.523-5.352 1.523-5.608 0-10.154-4.546-10.154-10.154S6.392 1.846 12 1.846s10.154 4.546 10.154 10.153c0 .933-.126 1.836-.361 2.694"
    />
    <path
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M4.257 11.008a14.5 14.5 0 0 1 7.74-2.221c2.845 0 5.499.814 7.742 2.22M10.303 19.618c0-3.593-1.861-6.137-4.157-6.137-.6 0-1.169.199-1.683.556M13.738 19.618c0-3.593 1.86-6.137 4.156-6.137.585 0 1.141.19 1.646.53"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M13.54 12.59a1.543 1.543 0 1 1-3.085 0 1.543 1.543 0 0 1 3.085 0Z"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M16.061 18.662a7.804 7.804 0 1 1 3.317-4.125"
    />
  </svg>
);
export const SteeringWheelIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
